exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.image-border[data-v-b09f1024] {\n  border: 2px solid #FFC107;\n}\n", ""]);

// exports
